<script setup>
import { getPassengersText } from '@js/utils/flight.js';
import PassengersAdultsAndChildren from './PassengersAdultsAndChildren.vue';
import PassengersYouth from './PassengersYouth.vue';

const passengers = defineModel('passengers', {
	required: true,
	type: Object,
	default: () => ({
		adults: 1,
		child: {
			count: 0,
			ages: []
		},
		youth: {
			count: 0,
			ages: []
		},
		activeView: 'default',
		isYouthTicketEnabled: false
	})
});

const passengersText = computed(() => getPassengersText(passengers.value, passengers.value.activeView === 'youth', true));

const isAgesMissing = computed(() => {
	if (passengers.value.activeView === 'default' && passengers.value?.child?.count > 0) {
		return passengers.value?.child.ages.includes(null);
	}
	if (passengers.value.activeView === 'youth' && passengers.value?.youth?.count > 0) {
		return passengers.value?.youth.ages.includes(null);
	}
	return false;
});

function setActiveView (view) {
	passengers.value.activeView = view;
}

function close () {
	window.searchBox.blurFields();
}
</script>

<template>
  <div
    class="abSearchBox__passengers abSearchBox__passengers--showAges"
    tabindex="0"
    :class="{
      'abSearchBox__passengers--showAge': passengers?.child?.count > 0
    }"
    :aria-label="$l('ariaLabels.customizePassengers')"
    role="button"
  >
    <span class="abSearchBox__label">{{ $l('global.simplePhrases.travelers') }}</span>
    <span class="abSearchBox__value abSearchBox__value--small" v-html="passengersText" />
    <div
      class="abSearchBox__menu"
      role="menu"
      aria-hidden="true"
    >
      <div class="abPassengers">
        <PassengersAdultsAndChildren
          v-if="passengers.activeView === 'default'"
          v-model:passengers="passengers"
          @changeView="setActiveView('youth')"
        />
        <PassengersYouth
          v-if="passengers.isYouthTicketEnabled && passengers.activeView === 'youth'"
          v-model:passengers="passengers"
          @changeView="setActiveView('default')"
        />
        <div class="abPassengers__apply">
          <button
            class="abPassengers__applyBtn abBtn abBtn--block abBtn--blueWhite tab-apply"
            role="menuitem"
            :disabled="isAgesMissing"
            tabindex="-1"
            @click="close"
          >
            <span>{{ $l('global.simplePhrases.apply') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
